import { render, staticRenderFns } from "./thirdPlatformSku.vue?vue&type=template&id=27b41c61&"
import script from "./thirdPlatformSku.vue?vue&type=script&lang=js&"
export * from "./thirdPlatformSku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports